var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "datasets" } },
    [
      _c("Message", { attrs: { bindTo: "error" } }),
      _vm._v(" "),
      _vm.loading
        ? _c("div", { staticClass: "loading" }, [
            _c("i", { staticClass: "icon circle notch spin" }),
          ])
        : _c("div", [
            _c(
              "div",
              { staticClass: "top-banner ui equal width grid middle aligned" },
              [
                _c("div", { staticClass: "column" }, [
                  _c("h1", [_vm._v(_vm._s(_vm.orgName))]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "column right aligned" }, [
                  _c(
                    "button",
                    {
                      staticClass: "ui primary button icon",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.handleNew()
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "ui icon add" }),
                      _vm._v(" Create Dataset"),
                    ]
                  ),
                ]),
              ]
            ),
            _vm._v(" "),
            _c("div", {}, [
              _c("div", { staticClass: "ui stackable grid" }, [
                _c("div", { staticClass: "six wide column" }, [
                  _c("div", { staticClass: "ui icon input fluid" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.searchQuery,
                          expression: "searchQuery",
                        },
                      ],
                      attrs: {
                        type: "text",
                        placeholder: "Search datasets...",
                      },
                      domProps: { value: _vm.searchQuery },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.searchQuery = $event.target.value
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("i", { staticClass: "search icon" }),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "four wide column" }, [
                  _c(
                    "div",
                    {
                      ref: "visibilityFilter",
                      staticClass: "ui selection dropdown",
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.visibilityFilter,
                            expression: "visibilityFilter",
                          },
                        ],
                        attrs: { type: "hidden", name: "visibility" },
                        domProps: { value: _vm.visibilityFilter },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.visibilityFilter = $event.target.value
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("i", { staticClass: "dropdown icon" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "default text" }, [
                        _vm._v("All Visibilities"),
                      ]),
                      _vm._v(" "),
                      _vm._m(0),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "six wide column" }),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "table",
              { staticClass: "ui selectable sortable celled table" },
              [
                _c("thead", [
                  _c("tr", [
                    _c(
                      "th",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.sortBy("name")
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "database icon" }),
                        _vm._v(" Dataset\n                        "),
                        _vm.sortColumn === "name"
                          ? _c("i", {
                              class:
                                _vm.sortDirection === "asc"
                                  ? "caret up icon"
                                  : "caret down icon",
                            })
                          : _vm._e(),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.sortBy("creationDate")
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                        Creation Date\n                        "
                        ),
                        _vm.sortColumn === "creationDate"
                          ? _c("i", {
                              class:
                                _vm.sortDirection === "asc"
                                  ? "caret up icon"
                                  : "caret down icon",
                            })
                          : _vm._e(),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.sortBy("entries")
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                        Files\n                        "
                        ),
                        _vm.sortColumn === "entries"
                          ? _c("i", {
                              class:
                                _vm.sortDirection === "asc"
                                  ? "caret up icon"
                                  : "caret down icon",
                            })
                          : _vm._e(),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.sortBy("size")
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                        Size\n                        "
                        ),
                        _vm.sortColumn === "size"
                          ? _c("i", {
                              class:
                                _vm.sortDirection === "asc"
                                  ? "caret up icon"
                                  : "caret down icon",
                            })
                          : _vm._e(),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.sortBy("visibility")
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                        Visibility\n                        "
                        ),
                        _vm.sortColumn === "visibility"
                          ? _c("i", {
                              class:
                                _vm.sortDirection === "asc"
                                  ? "caret up icon"
                                  : "caret down icon",
                            })
                          : _vm._e(),
                      ]
                    ),
                    _vm._v(" "),
                    _c("th", { staticClass: "center aligned" }, [
                      _vm._v("Actions"),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  [
                    _vm._l(_vm.paginatedDatasets, function (ds) {
                      return _c(
                        "tr",
                        {
                          key: ds.slug,
                          staticClass: "clickable-row",
                          on: {
                            click: function ($event) {
                              return _vm.viewDataset(ds)
                            },
                          },
                        },
                        [
                          _c("td", { staticClass: "ds-name" }, [
                            _vm._v(_vm._s(ds.slug)),
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(_vm._s(_vm.formatDate(ds.creationDate))),
                          ]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(ds.entries))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(_vm.bytesToSize(ds.size)))]),
                          _vm._v(" "),
                          _c("td", [
                            ds.visibility === 2
                              ? _c("div", [
                                  _c("i", { staticClass: "unlock icon" }),
                                  _vm._v(
                                    _vm._s(_vm.getVisibilityText(ds.visibility))
                                  ),
                                ])
                              : ds.visibility === 1
                              ? _c("div", [
                                  _c("i", { staticClass: "unlock icon" }),
                                  _vm._v(
                                    _vm._s(_vm.getVisibilityText(ds.visibility))
                                  ),
                                ])
                              : _c("div", [
                                  _c("i", { staticClass: "lock icon" }),
                                  _vm._v(
                                    _vm._s(_vm.getVisibilityText(ds.visibility))
                                  ),
                                ]),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "center aligned" }, [
                            _c(
                              "button",
                              {
                                staticClass: "ui button icon small grey",
                                class: { loading: ds.editing },
                                attrs: { disabled: ds.editing || ds.deleting },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.handleEdit(ds)
                                  },
                                },
                              },
                              [_c("i", { staticClass: "ui icon pencil" })]
                            ),
                            _vm._v(" "),
                            _vm.canDelete
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "ui button icon small negative",
                                    class: { loading: ds.deleting },
                                    attrs: {
                                      disabled: ds.deleting || ds.editing,
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.handleDelete(ds)
                                      },
                                    },
                                  },
                                  [_c("i", { staticClass: "ui icon trash" })]
                                )
                              : _vm._e(),
                          ]),
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _vm.paginatedDatasets.length === 0
                      ? _c("tr", [_vm._m(1)])
                      : _vm._e(),
                  ],
                  2
                ),
                _vm._v(" "),
                _c("tfoot", [
                  _c("tr", [
                    _c("th", { attrs: { colspan: "6" } }, [
                      _c("div", { staticClass: "ui grid three column" }, [
                        _c(
                          "div",
                          { staticClass: "column left aligned middle aligned" },
                          [
                            _c("div", { staticClass: "ui left floated" }, [
                              _vm._v(
                                "\n                                    Showing " +
                                  _vm._s(
                                    _vm.paginatedDatasets.length > 0
                                      ? (_vm.currentPage - 1) *
                                          _vm.itemsPerPage +
                                          1
                                      : 0
                                  ) +
                                  " to\n                                    " +
                                  _vm._s(
                                    Math.min(
                                      _vm.currentPage * _vm.itemsPerPage,
                                      _vm.filteredDatasets.length
                                    )
                                  ) +
                                  " of " +
                                  _vm._s(_vm.filteredDatasets.length) +
                                  " datasets\n                                "
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "column center aligned middle aligned",
                          },
                          [
                            _vm.totalPages > 1
                              ? _c(
                                  "div",
                                  { staticClass: "ui pagination menu" },
                                  [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "item",
                                        class: {
                                          disabled: _vm.currentPage === 1,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.changePage(1)
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "angle double left icon",
                                        }),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        staticClass: "item",
                                        class: {
                                          disabled: _vm.currentPage === 1,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.changePage(
                                              _vm.currentPage - 1
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "angle left icon",
                                        }),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm._l(
                                      _vm.displayedPages,
                                      function (page, index) {
                                        return _c(
                                          "a",
                                          {
                                            key: "page-" + index,
                                            staticClass: "item",
                                            class: {
                                              active: _vm.currentPage === page,
                                              disabled:
                                                page === "ellipsis-1" ||
                                                page === "ellipsis-2",
                                            },
                                            on: {
                                              click: function ($event) {
                                                page === "ellipsis-1" ||
                                                page === "ellipsis-2"
                                                  ? null
                                                  : _vm.changePage(page)
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                        " +
                                                _vm._s(
                                                  page === "ellipsis-1" ||
                                                    page === "ellipsis-2"
                                                    ? "..."
                                                    : page
                                                ) +
                                                "\n                                    "
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        staticClass: "item",
                                        class: {
                                          disabled:
                                            _vm.currentPage === _vm.totalPages,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.changePage(
                                              _vm.currentPage + 1
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "angle right icon",
                                        }),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        staticClass: "item",
                                        class: {
                                          disabled:
                                            _vm.currentPage === _vm.totalPages,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.changePage(
                                              _vm.totalPages
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "angle double right icon",
                                        }),
                                      ]
                                    ),
                                  ],
                                  2
                                )
                              : _vm._e(),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "column right aligned middle aligned",
                          },
                          [
                            _c("div", { staticClass: "ui right floated" }, [
                              _vm._v(
                                "\n                                    Items per page\n                                    "
                              ),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.itemsPerPage,
                                      expression: "itemsPerPage",
                                    },
                                  ],
                                  staticClass: "ui dropdown compact",
                                  staticStyle: { "margin-left": "5px" },
                                  on: {
                                    change: function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.itemsPerPage = $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    },
                                  },
                                },
                                [
                                  _c("option", { attrs: { value: "5" } }, [
                                    _vm._v("5"),
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "10" } }, [
                                    _vm._v("10"),
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "25" } }, [
                                    _vm._v("25"),
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "50" } }, [
                                    _vm._v("50"),
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "100" } }, [
                                    _vm._v("100"),
                                  ]),
                                ]
                              ),
                            ]),
                          ]
                        ),
                      ]),
                    ]),
                  ]),
                ]),
              ]
            ),
          ]),
      _vm._v(" "),
      _vm.deleteDialogOpen
        ? _c("DeleteDatasetDialog", {
            attrs: { dsSlug: _vm.currentDsSlug },
            on: { onClose: _vm.handleDeleteClose },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.messageDialogOpen
        ? _c("MessageDialog", {
            attrs: { message: _vm.currentMessage },
            on: { onClose: _vm.handleMessageClose },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.dsDialogOpen
        ? _c("DatasetDialog", {
            attrs: {
              mode: _vm.dsDialogMode,
              model: _vm.dsDialogModel,
              forbiddenSlugs: _vm.forbiddenSlugs,
            },
            on: { onClose: _vm.handleDatasetClose },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "menu" }, [
      _c("div", { staticClass: "item", attrs: { "data-value": "all" } }, [
        _c("i", { staticClass: "filter icon" }),
        _vm._v("All"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "item", attrs: { "data-value": "0" } }, [
        _c("i", { staticClass: "lock icon" }),
        _vm._v("Private"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "item", attrs: { "data-value": "1" } }, [
        _c("i", { staticClass: "unlock icon" }),
        _vm._v("Unlisted"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "item", attrs: { "data-value": "2" } }, [
        _c("i", { staticClass: "unlock icon" }),
        _vm._v("Public"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "td",
      { staticClass: "center aligned", attrs: { colspan: "6" } },
      [
        _c("h3", [_vm._v("No datasets found")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "You can create a new dataset by clicking the create dataset button."
          ),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }